export default __webpack_public_path__ + "static/fishermans-rest-aebd3fdaed0bb575f4cab1ec615598a5.jpg";